import { lazyNamed } from 'src/utils/lazyNamed.ts';

export default {
  Helmet: lazyNamed(() => import('./Helmet.tsx'), 'Helmet'),
  AiChat: lazyNamed(() => import('./pages/Chat/index.tsx'), 'AiChat'),
  AiSettingsProvider: lazyNamed(() => import('./pages/Settings/Provider.tsx'), 'SettingsProvider'),
  AiSettingsAgents: lazyNamed(() => import('./pages/Settings/containers/Agents/index.tsx'), 'AgentsPage'),
  AiSettingsAgentForm: lazyNamed(() => import('./pages/Settings/containers/AgentForm/index.tsx'), 'AgentFormPage'),
  AiSettingsMcpServers: lazyNamed(() => import('./pages/Settings/containers/McpServers/index.tsx'), 'McpServersPage'),
  AiSettingsMcpServerForm: lazyNamed(() => import('./pages/Settings/containers/McpServerForm/index.tsx'), 'McpServerFormPage'),
  AiSettingsBrandKits: lazyNamed(() => import('./pages/Settings/containers/BrandKits/index.tsx'), 'BrandKitsPage'),
  AiSettingsBrandKitForm: lazyNamed(() => import('./pages/Settings/containers/BrandKitForm/index.tsx'), 'BrandKitFormPage'),
  AiSettingsUsage: lazyNamed(() => import('./pages/Settings/containers/Usage/index.tsx'), 'UsagePage'),
};
